import { createFileRoute } from "@tanstack/react-router";
import { TradeGuidePage, seoHead } from "@/components/hubs/HubPages";
import { TRADE_GUIDES } from "@/lib/regionalHubs";

const DATA = TRADE_GUIDES.find((x) => x.slug === "/learn/hvac-leads-colorado")!;

export const Route = createFileRoute("/learn/hvac-leads-colorado")({
  head: () => seoHead("/learn/hvac-leads-colorado", "How Colorado HVAC Companies Get More Calls | Guide", "Guide for Colorado HVAC companies: Google Maps, seasonal pages, maintenance plans, and weather-timed ads.", "article"),
  component: () => <TradeGuidePage guide={DATA} />,
});
